module.exports = __webpack_public_path__ + "img/SOLANA-logo.88d4f0a5.png";